module.exports = __webpack_public_path__ + "d67401712a1605b04dca029a1e57a7ae.pdf";